import React from 'react';
import { useUser, UserProvider } from './contexts/UserContext';
import Homepage from './components/Homepage';

/**
 * This component consumes the UserContext and passes a `key` to the Homepage.
 * When the user logs in or out, the key changes, forcing React to unmount
 * the old Homepage and mount a new one, ensuring all state is fresh.
 */
function AppContent() {
  const { user, loading } = useUser();

  // While the user session is loading, we can show a loader or nothing.
  // This prevents rendering the Homepage with a "logged-out" state initially.
  if (loading) {
    return <div className="container" aria-busy="true">Loading session...</div>;
  }

  return <Homepage key={user?.id || 'logged-out'} />;
}

export default function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}